'use client';

import { Typography, theme, IcChevronRight } from '@bgzt/ui';

import { LinkByEnvironment } from '~/components';
import { PROMOTION_2026_03 } from '~/app/_constants';

import styles from './TossPromotionBanner.module.css';

export const TossPromotionBanner = () => {
  return (
    <LinkByEnvironment href={PROMOTION_2026_03.EXHIBITION_URL} target="_blank">
      <div className={styles.container}>
        <Typography variant="L10" color={'gray-0'}>
          토스페이 결제 시
        </Typography>
        <Typography variant="L9" color={'gray-0'}>
          2,000원 즉시 할인
        </Typography>
        <IcChevronRight fill={theme.colors['gray-0']} size={10} />
      </div>
    </LinkByEnvironment>
  );
};
